import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback } from "reactstrap";
import Select from "react-select";

import { getPaymentCategories } from "common/services/payments.service";
import { normalize } from "common/lib/normalize";

const SelectPaymentCategory = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.paymentCategory && validation.errors.paymentCategory
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.paymentCategory &&
          validation.errors.paymentCategory
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPaymentCategories({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const options = useMemo(() => {
    const mainOptions = data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });

    mainOptions.unshift({ value: null, label: "None" });
    return mainOptions;
  }, [data]);

  return (
    <>
      <Label htmlFor="paymentCategory-field" className="form-label">
        Payment Category
      </Label>
      <Select
        name="paymentCategory"
        id="paymentCategory"
        value={
          validation.values.paymentCategory.value
            ? validation.values.paymentCategory
            : null
        }
        placeholder="Select payment category"
        onChange={(value: any) => {
          validation.setFieldValue("paymentCategory", value);
          validation.setFieldError("paymentCategory", "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("paymentCategory", true)}
        className={
          validation.touched.paymentCategory &&
          validation.errors.paymentCategory
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>{validation.errors.paymentCategory?.value}</FormFeedback>
    </>
  );
};

export default SelectPaymentCategory;
